'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib

// TODO 944 - Remove when user image design is completed
// import ReactDOM from 'react-dom';


// Components


// Components


// Actions


// Utils


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _UserAvatar = require('../../../../../components/userAvatar/UserAvatar');

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _ImageFileInput = require('../../../../../components/tools/images/ImageFileInput');

var _ImageFileInput2 = _interopRequireDefault(_ImageFileInput);

var _Overlay = require('../../../../../components/misc/Overlay');

var _Overlay2 = _interopRequireDefault(_Overlay);

var _currentUserActions = require('../../../../../user/currentUserActions');

var _fileValidator = require('../../../../../utils/services/file/fileValidator');

require('./AvatarPicker.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchUploadCurrentUserAvatar: function dispatchUploadCurrentUserAvatar(userId, imageFile) {
            return dispatch((0, _currentUserActions.uploadCurrentUserAvatar)(userId, imageFile));
        }
    };
};

var AvatarPicker = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(AvatarPicker, _React$Component);

    function AvatarPicker(props) {
        _classCallCheck(this, AvatarPicker);

        var _this = _possibleConstructorReturn(this, (AvatarPicker.__proto__ || Object.getPrototypeOf(AvatarPicker)).call(this, props));

        _this.openFileSelect = _this.openFileSelect.bind(_this);
        _this.uploadImage = _this.uploadImage.bind(_this);
        return _this;
    }

    /**
     * Delegates the click event on the fake file upload input to the real, hidden one.
     */


    _createClass(AvatarPicker, [{
        key: 'openFileSelect',
        value: function openFileSelect(event) {
            // TODO 944 - Remove when user image design is completed
            // const { imageFileInput } = this.refs;
            // const fileInputDomNode = ReactDOM.findDOMNode(imageFileInput);
            // fileInputDomNode.click();
        }
    }, {
        key: 'uploadImage',
        value: function uploadImage(imageFile) {
            var _props = this.props,
                user = _props.user,
                dispatchUploadCurrentUserAvatar = _props.dispatchUploadCurrentUserAvatar;


            var validationErrors = (0, _fileValidator.validateImageFile)(imageFile);
            if (validationErrors) {
                // TODO if validation errors, show them to the user
                return;
            }

            dispatchUploadCurrentUserAvatar(user.get('_id'), imageFile);
        }
    }, {
        key: 'render',
        value: function render() {
            var user = this.props.user;

            return _react2.default.createElement(
                'div',
                { className: 'AvatarPicker', onClick: this.openFileSelect },
                _react2.default.createElement(_ImageFileInput2.default, { ref: 'imageFileInput', id: 'avatar', uploadImage: this.uploadImage }),
                _react2.default.createElement(_UserAvatar2.default, { user: user, size: 'large' }),
                _react2.default.createElement(
                    _Overlay2.default,
                    null,
                    'Change'
                )
            );
        }
    }]);

    return AvatarPicker;
}(_react2.default.Component)) || _class);


AvatarPicker.propTypes = {
    user: _propTypes2.default.object.isRequired,
    uploadUserAvatar: _propTypes2.default.func,
    dispatchUploadCurrentUserAvatar: _propTypes2.default.func
};

exports.default = AvatarPicker;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/avatar/AvatarPicker.js
// module id = 2170
// module chunks = 0